import React from 'react';
import { translate } from 'react-i18next';
import { Rating, Segment, Header, Button, Container, Grid, Message } from 'semantic-ui-react';

import {colors, fontSizes} from 'style';

import styleDef from './style.js'
var style= {
    ...styleDef,
};

const Satisfaction = ({t, busy, rating, error, complete, onChange, onSkip, onSave}) => (
    <div style={style.container}>
        <div style={style.containerDiv}>
            <div style={style.segment}>
                <Grid style={style.grid} centered columns={1}>
                    <Grid.Row style={style.row} verticalAlign='top'>
                        <Grid.Column verticalAlign='top'>
                            <div>
                                <div style={style.header}>{t('Rate your current mood')}</div>
                                <div style={style.iconWrapper}>
                                    <i style={style.icon} className='icon-brain' />
                                </div>
                            </div>
                            <div style={style.ratingsWrapper}>
                                <Rating style={style.ratings} value={rating} onRate={(e,data)=>{onChange(data.rating)}} maxRating="5"/>
                            </div>
                            {!complete ? (
                                    <Button style={(!rating || error) ?  style.disabledButton : style.tealButton} disabled={!rating || error} onClick={onSave}>{t('Continue')}</Button>
                                ) : (
                                    <div style={style.message}>{t('Saved')}</div>
                                )
                            }
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row style={style.row} verticalAlign='middle'>
                        <Grid.Column verticalAlign='middle'>
                        </Grid.Column>
                    </Grid.Row>
                  
                    <Grid.Row style={style.row} verticalAlign='bottom'>
                        <Grid.Column verticalAlign='bottom' textAlign='left'>
                            {error &&
                            <Message negative>
                                <Message.Header>{t('Error')}</Message.Header>
                                <p>{error}</p>
                            </Message>
                            }
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        </div>
    </div>
);

export default translate('onboarding')(Satisfaction);



// WEBPACK FOOTER //
// ./src/modules/onboarding/Satisfaction.js